
import { defineComponent, ref } from "vue";
import Permission from "@/core/config/Permission";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import axios from "@/axios-instance"
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { hideModal } from "@/core/helpers/dom";
import Dropzone from "dropzone";
import { debounce } from "debounce";


interface ICustomer {
    id?: string;
    ses_schoolname?: string;
    ses_coursename?: string;
    ses_class?: string;
    index?: number;
    
    

}
interface IPagination {
    currentPage: number;
    total: number;
    limit: number;
}
interface IData {
    name: string;
    type: string;
    code: string;
}
export default defineComponent({
    name: "Combination-code",
    components: {
        Datatable,
    },
    data() {
        return {
            btnSave: false,
        }
    },
    watch: {
        search: debounce(async function (this) {
            this.searchItems()
        }, 300),
        tableData(newQuestion, oldQuestion) {
            this.initCustomers.splice(0, this.tableData.length, ...this.tableData);
        }
    },
    methods: {
        AsyncSIS() {

        },
        SaveFromAsyncSIS() {

        },
        importFile() {
            setTimeout(()=>{
                this.initDropzone()
            },100)
        },
        getCookie(name: string): string|null {
            const nameLenPlus = (name.length + 1);
            return document.cookie
                .split(';')
                .map(c => c.trim())
                .filter(cookie => {
                return cookie.substring(0, nameLenPlus) === `${name}=`;
                })
                .map(cookie => {
                return decodeURIComponent(cookie.substring(nameLenPlus));
                })[0] || null;
        },
        initDropzone() {
            let this_ = this
            if (Dropzone.instances.length > 0) {
                Dropzone.instances.forEach((e: any) => {
                    e.off();
                    e.destroy();
                });
            }
            let myDropzone = new Dropzone("#id_dropzone", { 
                url:`${process.env.VUE_APP_API_URL}/admission/passed/synchronize`,
                headers:{"Authorization":'Bearer ' + this.getCookie("accessToken")}, 
                dictDefaultMessage: "Nhấn vào đây để import file excel",
                dictInvalidFileType: "Bạn không thể tải tệp không đúng định dạng",
                dictFileTooBig: "Kích thước tệp quá lớn. Tối đa 25MB",
                dictMaxFilesExceeded: "Bạn chỉ được upload tối đa 1 files",
                maxFilesize: 25,
                maxFiles: 1,
                addRemoveLinks: true,
                acceptedFiles: `text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,
                init: function () {
                    var startUpload = document.getElementById("uploadFiles");
                    myDropzone = this;
                    myDropzone.removeAllFiles()
                    document.querySelectorAll(".dz-preview").forEach(e => e.remove());
                    startUpload?.addEventListener("click", function (file) {
                        // console.log('file',file)
                        myDropzone.processQueue();
                        
                    });
                    this.on("removedfile",async function (file) {
                        // if(file && file.fileName) {
                        //     await axios.delete(`/admission/file/${file.fileName}`)
                        // }
                    });
                    this.on("success",async function (file, response) {
                        console.log('response',response)
                    });
                    this.on("error",function (file, response) {
                        console.log('response',response)
                        Swal.fire({
                            text: response.message,
                            icon: "error",
                            buttonsStyling: false,
                            confirmButtonText: "Trở lại",
                            customClass: {
                                confirmButton: "btn btn-primary",
                            },
                        }).then(() => {
                            Swal.close()
                        });  

                    })
                }
            });
        },
        callModalAddApp(e) {
            e.preventDefault()
            this.isEdit = false
            this.kt_modal_add_combination?.click()
            this.resetDataForm()
        },
        resetDataForm() {
            if (!this.formRef) return
            this.formRef.resetFields()
            let temp = {
                "type": '',
                "name": "",
                "code": "",
            }
            this.formData = temp
        },
        deleteRow(record) {
            Swal.fire({
                text: `Bạn có muốn xóa môn học này không?`,
                icon: "question",
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Đồng ý",
                cancelButtonText: "Trở lại",
                customClass: {
                    confirmButton: "btn btn-primary order-2",
                    cancelButton: "btn btn-light order-1",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    let index = this.tableData.findIndex(item => item.id == record.id)
                    this.tableData.splice(index, 1);
                    axios.delete(`/setting/subject/${record.id}`)
                }
                Swal.close()
            });
        },
        async setDataForm(record) {
            this.resetDataForm()
            this.idFormEdit = record.id
            this.formData = record
            this.isEdit = true
            this.kt_modal_add_combination?.click()

        },
        async getData() {
            this.tableData = []
            this.initCustomers = []
            await axios.get(`/setting/subject`)
            .then(({ data }) => {
                // data.forEach(item => {
                    
                // })
                let temp = {
                        id: '1231esf',
                        index: 1,
                        ses_class: 'CLS-00001019',
                        ses_coursename: 'Tinh thần doanh chủ',
                        ses_schoolname: 'Khoa Kinh doanh',
                    }
                    this.tableData.push(temp as any)
            })
            .catch(({ response }) => {
                console.log('err', response)
            });
            this.initCustomers.splice(0, this.tableData.length, ...this.tableData);
        },
    },

    async mounted() {
        this.getData()
    },
    setup() {
        Dropzone.autoDiscover = false;
        const kt_modal_add_combination = ref<null | HTMLElement>(null);
        const addCombinationModalRef = ref<null | HTMLElement>(null);
        const isEdit = ref(false);
        const idFormEdit = ref('');

        const pagination = ref<IPagination>({
            currentPage: 1,
            total: 0,
            limit: 1000,
        });
        const tableHeader = ref([
            {
                name: "STT",
                key: "index",
                sortable: false,
                class: "w-30px text-center"
            },
            {
                name: "Lớp học",
                key: "ses_class",
                sortable: true,
            },
            {
                name: "Môn học",
                key: "ses_coursename",
                sortable: true,
            },
            {
                name: "Ngành",
                key: "ses_schoolname",
                sortable: true,
            },
        ]);
        const optionType = [{ label: 'Ngoại ngữ', value: 'foreign_lang' }, { label: 'Giáo dục thể chất', value: 'physical_edu' }]
        const formData = ref<IData>(
            { 
                "name": "",
                "code": "",
                "type": "" 
            })
        const tableData = ref<Array<ICustomer>>([]);
        const initCustomers = ref<Array<ICustomer>>([]);
        const arrMajors = ref([]) as any;
        const formRef = ref<HTMLFormElement | null>(null);
        const rules = ref({
            name: {
                required: true,
                message: "Vui lòng điền trường này",
                trigger: "change",
            },
            type: {
                required: true,
                message: "Vui lòng điền trường này",
                tringger: "change"
            },
            code: {
                required: true,
                message: "Vui lòng điền trường này",
                tringger: "change"
            }
        })
        const submit = () => {
            if (!formRef.value) {
                return;
            }
            formRef.value.validate(async (valid) => {
                if (valid) {
                    let method = isEdit.value ? 'put' : 'post'
                    let id = isEdit.value ? `/${idFormEdit.value}` : ''
                    let data = {
                        "name": formData.value.name != "" ? formData.value.name : undefined,
                        "code": formData.value.code != "" ? formData.value.code : undefined,
                        "type": formData.value.type != "" ? formData.value.type : undefined
                    }
                    await axios[method](`/setting/subject${id}`, data)
                        .then(({ data }) => {
                            let temp = {
                                id: data.id,
                                name: data.name,
                                code: data.name,
                                type: data.type
                            }
                            if (!isEdit.value) {
                                tableData.value.push(temp)
                                initCustomers.value.push(temp)
                            }
                            else {
                                let index = tableData.value.findIndex(item => item.id == data.id)
                                if (index >= 0) {
                                    tableData.value[index] = temp
                                    initCustomers.value[index] = temp
                                }
                            }
                            hideModal(addCombinationModalRef.value);
                        })
                        .catch(({ response }) => {
                            console.log('err', response)
                        });

                } else {
                    return false;
                }
            });
        };
        const search = ref<string>("");
        const searchItems = () => {
            tableData.value.splice(0, tableData.value.length, ...initCustomers.value);
            if (search.value !== "") {
                let results: Array<ICustomer> = [];
                for (let j = 0; j < tableData.value.length; j++) {
                if (searchingFunc(tableData.value[j], search.value)) {
                    results.push(tableData.value[j]);
                }
                }
                tableData.value.splice(0, tableData.value.length, ...results);
            }
        };
        const searchingFunc = (obj, value): boolean => {
            obj = JSON.parse(JSON.stringify(obj))
            for (let key in obj) {
                if (obj[key] && (typeof obj[key] === "string")) {
                if (obj[key].toUpperCase().indexOf(value.toUpperCase()) != -1) {
                    return true;
                }
                }
            }
            return false;
        };
        return {
            optionType,
            kt_modal_add_combination,
            formRef,
            rules,
            addCombinationModalRef,
            pagination,
            tableHeader,
            tableData,
            Permission,
            arrMajors,
            submit,
            formData,
            isEdit,
            idFormEdit,
            search,
            searchItems,
            initCustomers,
        };
    },
});
